import { CommonModule } from '@angular/common';
import { Component, ElementRef, AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { HttpService } from '../../services/http-service/http.service';
import { IProductModel } from '../../models/models.interface';
import { environment } from '../../../environments/environment';
import { UserService } from '../../services/user-service/user.service';
import { Router, RouterLink } from '@angular/router';

interface Product {
  id: number;
  name: string;
  category: string;
  price: number;
  rating: number;
  image: string;
}


@Component({
  selector: 'app-fetured-products',
  imports: [CommonModule, RouterLink],
  templateUrl: './fetured-products.component.html',
  styleUrl: './fetured-products.component.scss'
})
export class FeturedProductsComponent implements OnInit, AfterViewInit, OnDestroy {
  products: IProductModel[] = [];


  private observer!: IntersectionObserver;

  constructor(private elRef: ElementRef, private http: HttpService, private router: Router) {}

  ngOnInit(): void {
     this.http.get<IProductModel[]>(`${environment.API_ENDPOINT}/api/home/featured`).subscribe(res => {
          this.products = res;
          setTimeout(() => this.ngAfterViewInit(),1000);
        })
  }

  ngAfterViewInit() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-fade-in');
            entry.target.classList.remove('opacity-0');
            this.observer.unobserve(entry.target);
          }
        });
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
      }
    );

    const elements = this.elRef.nativeElement.querySelectorAll('.appear-on-scroll');
    elements.forEach((el: Element) => this.observer.observe(el));
  }

  ngOnDestroy() {
    const elements = this.elRef.nativeElement.querySelectorAll('.appear-on-scroll');
    elements.forEach((el: Element) => this.observer.unobserve(el));
  }

  onAddToCart(product: IProductModel) {
    const cart = {
      productId: product.id,
      quantity: 1
    }

    this.http.post(`${environment.API_ENDPOINT}/api/user/cart`, cart).subscribe(res => {
      console.log(res);
    });
  }

  onProductClick(product: IProductModel) {
    console.log("product clicked:", product);
    this.router.navigate(['shop',product.id]);
  }
  calcRating(product: IProductModel) {
    let rating = product.totalRatings;
    let star = product.totalStars;
    if(rating == 0){
      return ""
    }
    else{
      return star/rating;
    }
  }

  discountCalculator(product: IProductModel) {

    if (!product.retailPrice || product.retailPrice <= 0) {
      return ''; // No discount if retail price is not set or invalid
    }

    let discount = product.retailPrice - product.price;
    let percent = (discount / product.retailPrice) * 100;
    return `-${Math.round(percent)}%`;
  }
}
